import * as Yup from "yup";

// form field names
export type TFormFieldNames = "role_id" | "description";

// initial values for the form
export const formInitialValues = {
  role_id: "",
  description: "",
};

// validation schema for the form
export const YupValidationSchema = Yup.object().shape({
  role_id: Yup.string()
    .required("Please enter the role title")
    .matches(/^[a-z0-9\-_]+$/, 'Only lowercase characters, numbers, hyphens, and underscores are allowed'),

  description: Yup.string().required("Please enter the description"),
});
//validation schema for sysadmin add role
export const roleDetailsSysadminYupValidationSchema = Yup.object().shape({
  role_id: Yup.string()
    .required("Role title is required")
    .matches(
      /^[a-z0-9\-_!@#$%^&*()+=,./<>?;:'"[\]{}|~`\\]+$/,
      "Only lowercase characters, numbers and special characters are allowed (spaces not allowed)"
    ),
  description: Yup.string().required("Description is required"),
});
